export default "__VITE_ASSET__Qf7xXXwH__"